// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "66") return "js/2.1.4-production-master/app.66.316a67a221f4d9b1.chunk.js";
  // return url for filenames based on template
  return "" + chunkId + ".javascript"
}